import React, { useEffect, useState } from "react";

import { Link, useLocation, useSearchParams } from "react-router-dom";
import Toggle from "react-toggle";
import { useTheme } from "../../context/ThemeContext";

import NotificationsComponent from "../Notifications/NotificationsComponent";
import UserAccountInfo from "../UserAccountInfo";

import sun from "../../images/sun.png";
import moon from "../../images/moon.png";
import SystemInfo from "../../util/SystemInfo";
import { useFeedBack } from "../../context/FeedBackContext";

const Header = ({ onNote }) => {

    const { changeBackground } = useTheme();

    const { currentTitle } = useFeedBack()

    const location = useLocation();

    const [searchParams] = useSearchParams();

    const [showHeader, setShowHeader] = useState(true);

    const [darkMode, setDarkMode] = useState(false);

    const [nameForUpdate, setNameForUpdate] = useState('');

    useEffect(() => {
        const dark = localStorage.getItem('CSI-PEDIDOS-DARKMODE') === 'true' ? true : false;
        setDarkMode(dark);
    }, []);

    useEffect(() => {
        if (nameForUpdate) {
            document.title = `${SystemInfo?.name} - ${nameForUpdate}`;
        } else {
            document.title = SystemInfo?.name;
        }
    }, [nameForUpdate])

    useEffect(() => {
        setNameForUpdate(searchParams?.get('name'));
    }, [searchParams])

    useEffect(() => {
        if (darkMode) {
            changeBackground({ value: "dark", label: "dark" });
        } else {
            changeBackground({ value: "light", label: "light" });
        }

        localStorage.setItem('CSI-PEDIDOS-DARKMODE', darkMode);
    }, [darkMode]);

    return (
        <>
            {
                showHeader &&
                <div className={`header bottom-shadow ${darkMode ? "" : "bg-white"}`} style={{ zIndex: 8 }}>
                    <div className="header-content">
                        <nav className="navbar navbar-expand">
                            <div className="collapse navbar-collapse justify-content-between">
                                <div className="header-left">
                                    <div className="dashboard_bar" style={{ textTransform: "capitalize" }}>
                                        {
                                            currentTitle?.subTitle &&
                                            <small style={{ display: 'block', fontSize: 10 }}>
                                                - {currentTitle?.subTitle}
                                            </small>
                                        }
                                        <p style={{ margin: 0, fontSize: 20 }}>
                                            {currentTitle?.title}
                                        </p>
                                    </div>
                                </div>
                                <ul className="navbar-nav header-right main-notification" style={{ alignItems: "center" }}>
                                    {/* {<NotificationsComponent />} */}
                                    <div style={{ margin: '0 30px', display: 'flex', alignItems: 'center' }}>
                                        {
                                            !darkMode ?
                                                <img className="d-none d-md-block" style={{ maxWidth: '40px', marginRight: 10 }} src={sun} alt="" />
                                                :
                                                null
                                        }
                                        <Toggle onChange={() => { setDarkMode((oldDarkMode) => !oldDarkMode) }} checked={darkMode} />
                                        {
                                            darkMode ?
                                                <img className="d-none d-md-block" style={{ maxWidth: '40px', marginLeft: 10 }} src={moon} alt="" />
                                                :
                                                null
                                        }
                                    </div>
                                    <UserAccountInfo />
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            }
            <div className="text-center position-fixed" style={{ right: '49vw', top: showHeader ? '9vh' : 0, zIndex: 101 }}>
                <button style={{ fontSize: 15 }} className="btn m-0 p-0 text-primary btn-xs animate__animated animate__fadeInDown" onClick={() => setShowHeader((value) => !value)}>
                    {
                        showHeader ?
                            '▲'
                            :
                            '▼'
                    }
                </button>
            </div>
        </>
    );
};

export default Header;
